import { render, staticRenderFns } from "./exchangePrizeArea.vue?vue&type=template&id=60f80162&scoped=true&"
import script from "./exchangePrizeArea.vue?vue&type=script&lang=js&"
export * from "./exchangePrizeArea.vue?vue&type=script&lang=js&"
import style0 from "./exchangePrizeArea.vue?vue&type=style&index=0&id=60f80162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f80162",
  null
  
)

export default component.exports